export { CollectionHero } from "./CollectionHero";
export type { CollectionHeroProps } from "./CollectionHero";
